export default ({
    path,
    method = "POST",
    body
}) => new Promise(async(resolve) => {
    fetch(`${window.location.origin}/api${path}`, {
        method,
        headers: {
            "Sec-Fetch-Site": "none",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body),
        
    }).then(res => res.json()).then(res => {
        return resolve(res);
    }).catch(e => {
        console.log(e);
        return resolve({
            success: false,
            error: "notifications.system.apiError"
        });
    });
});